export default "__VITE_ASSET__DlgXnW6R__"